import { inject, injectable } from "inversify";
import {
  IBoletosAvisosResponse,
  IFinaceiroGateway
} from "../../ports/financeiro/FinaceiroGateway";
import { IDefaultHorizonsResponse } from "@/core/services/financas/gateways/types";
import { DITypes } from "@/core/@types/types";
import "reflect-metadata";
import { type HttpClient } from "@/core/services/protocols/types";

@injectable()
export default class FinanceiroGatewayAdapter implements IFinaceiroGateway {
  @inject(DITypes.HORIZONS_HTTP_CLIENT)
  private httpHorizons!: HttpClient;

  async getBoletosAviso(): Promise<
    IDefaultHorizonsResponse<IBoletosAvisosResponse> | undefined
  > {
    const response = await this.httpHorizons?.get<
      IDefaultHorizonsResponse<IBoletosAvisosResponse> | undefined
    >({
      url: "/financas/financeiro/v1/obter-boletos-abertos"
    });

    if (response.statusCode !== 200) return;

    return response.body;
  }
}
